(function () {
  function syncVideos(swiper) {
    swiper.slides.forEach((slide) => {
      const video = slide.querySelector('.hero-banner__video');
      if (!video) return;

      if (slide.classList.contains('swiper-slide-active')) {
        const playVideo = () => {
          video.play().catch(() => {});
        };

        if (slide.dataset.heroVideoReady === 'true') {
          playVideo();
          return;
        }

        slide.dataset.heroVideoReady = 'true';

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(playVideo, { timeout: 2000 });
        } else {
          window.setTimeout(playVideo, 1500);
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function initHeroBanner(root) {
    const hero = root.matches('.hero-banner') ? root : root.querySelector('.hero-banner');
    if (!hero) return;

    const swiperEl = hero.querySelector('.hero-banner__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    const autoplay = hero.dataset.autoplay === 'true' && slideCount > 1;
    const delay = Number(hero.dataset.autoplaySpeed) || 5000;

    const swiper = new Swiper(swiperEl, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: slideCount > 1,
      speed: 600,
      slidesPerView: 1,
      allowTouchMove: slideCount > 1,
      autoplay: autoplay ? { delay, disableOnInteraction: false } : false,
      pagination: {
        el: hero.querySelector('.hero-banner__pagination'),
        clickable: true,
        bulletClass: 'hero-banner__dot',
        bulletActiveClass: 'is-active',
        renderBullet(index, className) {
          return `<button type="button" class="${className}" aria-label="Show slide ${index + 1}"></button>`;
        },
      },
      navigation: {
        nextEl: hero.querySelector('.hero-banner__next'),
        prevEl: hero.querySelector('.hero-banner__prev'),
      },
      on: {
        init(instance) {
          syncVideos(instance);
        },
        slideChange(instance) {
          syncVideos(instance);
        },
      },
    });

    hero._heroSwiper = swiper;
  }

  function initAll() {
    document.querySelectorAll('.hero-banner').forEach(initHeroBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHeroBanner(event.target);
  });
})();
